import moment from 'moment';
import { DATE_FORMAT } from '../utils/query';
import api, { optimiseApi } from './axiosApi';
import {
  getDriverIdFromDriverCode,
  mapDriverForServer,
} from '../features/driverDetails/model';

export const fetchDepotDrivers = async (depotCode, date) => {
  const { data } = await api.get(
    `/depot/${depotCode}/driver?date=${moment
      .utc(date, DATE_FORMAT)
      .toDate()
      .getTime()}`
  );
  return data;
};

export const fetchVehicles = async () => {
  const { data } = await api.get(`/reference/vehicletype`);

  return data;
};

export const changePassword = async (driverCode) => {
  const driverId = getDriverIdFromDriverCode(driverCode);
  const {
    data: { password },
  } = await api.put(
    `/driver/password`,
    {
      driverId,
    },
    {
      ignoreSnackbarError: true,
    }
  );
  return password;
};

export const createTemporaryDriver = async ({
  driver,
  depotCode,
  date,
  routeId,
}) => {
  try {
    const body = {
      driver: mapDriverForServer({ driver }),
      date,
      routeId,
    };

    const { data } = await api.post(`/depot/${depotCode}/driver`, body, {
      ignoreSnackbarError: true,
    });
    return data;
  } catch {}
};

export const assignRouteDriver = async ({
  driver,
  depotCode,
  date,
  routeId,
  driverCode,
}) => {
  const body = {
    date: moment.utc(date, DATE_FORMAT).toDate().getTime(),
    driver: mapDriverForServer({ driver }),
  };

  const { data } = await optimiseApi.post(
    `/depot/${depotCode}/route/${routeId}/driver/${driverCode}`,
    body,
    {
      ignoreSnackbarError: true,
    }
  );

  return data;
};

export const createDriver = async ({ driver, depotCode, date, routeId }) => {
  const { password, driverCode } = await createTemporaryDriver({
    date: moment.utc(date, DATE_FORMAT).toDate().getTime(),
    driver,
    depotCode,
    routeId,
  });
  await assignRouteDriver({
    driver: { ...driver, odfRouteOwner: null },
    depotCode,
    date,
    routeId,
    driverCode,
  });
  return { password, driverCode };
};

export const updateDriver = async ({
  driver,
  depotCode,
  date,
  routeId,
  driverCode,
}) => {
  const body = {
    date: moment.utc(date, DATE_FORMAT).toDate().getTime(),
    routeId,
    driver: mapDriverForServer({ driver, driverCode }),
  };
  const { data } = await optimiseApi.put(`/depot/${depotCode}/driver`, body, {
    ignoreSnackbarError: true,
  });

  return data;
};
